import Vue from 'vue';

export default {
  // 发票列表
  getAssetsList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/selectListByPage', params);
  },
  // 获取开票信息
  getAssetsInfo (bidId) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/selectInfoById', bidId);
  },
  sendInfo (params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/applyInvoice', params);
  },
  getDetail (projectId, bidId, projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/invoiceDetails/' + projectId + '/' + bidId + '/' + projectType);
  },
  // 添加资产
  assetsSave (params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/save', params);
  },
  //  获取注册位置
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },

  //  获取唯一标识
  getTimestamp () {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getTimestamp');
  },
  // 添加资源资产
  addBatchAssets (params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/batch/addBatchAssets', params);
  },
  // 列表
  pageAssetsInfo (identification) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/pageAssetsInfo?identification=' + identification);
  },
  // 查看
  getbatchAssetsInfo (id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getAssetsInfo?id=' + id);
  },
  // 二级列表查看
  getSecondListInfo (id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getSecondListInfo?id=' + id);
  },
  // 删除
  deleteAssetsInfo (id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/deleteAssetsInfo?id=' + id);
  },
  // 添加所有资产
  addBatchAllAssets (params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/batch/addBatchAllAssets', params);
  },
  // 资源资产列表
  pageBatchAssets (pageSize, pageNum) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/pageBatchAssets?pageSize=' + pageSize + '&pageNum=' + pageNum);
  },
  // 资源资产列表
  getResourcesInfo (pageSize, pageNum, id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getInfo?pageSize=' + pageSize + '&pageNum=' + pageNum + '&id=' + id);
  },
  // 编辑列表
  batchgetUpdateBatchAllAssets (id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getUpdateBatchAllAssets?id=' + id);
  },
  // 编反显地址信息
  getUpdateBatchInfoAllAssets (id) {
    return Vue.axios.get('/api/v1.0/chanquan/assets/batch/getUpdateBatchInfoAllAssets?id=' + id);
  },
  // 添加所有资产
  updateBatchAllAssets (params) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/batch/updateBatchAllAssets', params);
  },
  // 资源资产列表
  getDictionaryByCode (parentCode, subCode) {
    return Vue.axios.get('/api/v1.0/chanquan/dictionary/getDictionaryByCode?parentCode=' + parentCode + '&subCode=' + subCode + '&dictId=ASSETS_MASSIF_TYPE');
  }
};
